<template>
    <div class="uik-breadcrumbs">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "UikBreadcrumbs"
}
</script>

<style lang="scss">
.uik-breadcrumbs {
    margin: 0;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    a {
        white-space: nowrap;
        position: relative;
        font-size: 13px;
        color: $textBase;
        margin: 0 10px;
        font-weight: normal;
        &:hover {
            color: $textMain;
        }
        &::before {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            font-family: 'uikon' !important;
            content: "\E921";
            position: absolute;
            font-size: 10px;
            left: -15px;
            color: $textSecondary !important;
            pointer-events: none;
        }
    }
    a:first-child {
        margin-left: 0;
        &::before {
            content: none;
        }
    }
    a:last-child {
        margin-right: 0;
    }
    &:hover {
        a {
            opacity: 0.7;
            &:hover {
                opacity: 1;
            }
        }
    }
    .router-link-active {
        color: $textBase !important;
        background: transparent !important;
        border: none !important;
        box-shadow: none !important;
        outline: none !important;
    }
}
</style>
